module.exports = __webpack_public_path__ + "img/chart_eidt_close.09fdf370.svg";